import { mobileQuery } from '@globals/themes/themeConstants'
import { AppEntityTypes } from '@kudos/http-client'
import Divider from '@mui/material/Divider'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { AppPermission } from '@shared/permissions'
import { T } from '@transifex/react'
import { ChecklistSection as ChecklistSectionType } from '../types/dashboard'
import ChecklistItem from './ChecklistItem'
import { LaunchSectionsEnum } from './content/checklistContent'

const containerStyle = {
  overflow: 'hidden',
  mt: 2,
}

const titleStyle = {
  mt: 0,
  [mobileQuery]: {
    mt: 0,
  },
}

type ChecklistSectionProps = {
  section: ChecklistSectionType
  onItemToggle?: (sectionId: string, itemId: string) => void
  onAlreadyOnActionUrl?: () => void
  expandedItemKey?: string
  hasAppPermission?: (app: AppEntityTypes, permission: AppPermission) => boolean
  isPending?: boolean
}

const ChecklistSection: React.FC<ChecklistSectionProps> = ({
  section,
  onItemToggle,
  onAlreadyOnActionUrl,
  expandedItemKey,
  hasAppPermission,
  isPending,
}) => {
  const handleItemToggle = (itemId: string) => {
    if (onItemToggle) {
      onItemToggle(section.key, itemId)
    }
  }

  // Filter items based on visibility
  const visibleItems = section.items.filter(item => {
    // Check if any subItems are visible
    const hasVisibleSubItems = item.subItems?.some(subItem => {
      if (typeof subItem.visible === 'function') {
        return subItem.visible(hasAppPermission || (() => true))
      }
      return subItem.visible !== false
    })

    return hasVisibleSubItems !== false
  })

  // Hide section if no items are visible
  if (visibleItems.length === 0) {
    return null
  }

  return (
    <>
      <Divider sx={{ mt: 3, mx: -2 }} />
      <Stack sx={containerStyle} spacing={1.5}>
        {section.key === LaunchSectionsEnum.LAUNCH && (
          <Typography variant="h3" sx={titleStyle}>
            <T _str="Ready to launch" />
          </Typography>
        )}
        {visibleItems.map(item => (
          <ChecklistItem
            key={item.key}
            item={item}
            onToggle={handleItemToggle}
            onAlreadyOnActionUrl={onAlreadyOnActionUrl}
            initiallyExpanded={item.key === expandedItemKey}
            hasAppPermission={hasAppPermission}
            isPending={isPending}
          />
        ))}
      </Stack>
    </>
  )
}

export default ChecklistSection
